<template>
  <div id="custom_dashboard_loading" class="vs-con-loading__container">
    <div class="flex flex-wrap">
      
      <vs-row style="margin-bottom: 1rem">
        <vs-col vs-type="flex" vs-justify="center">
          <h1>Dashboard</h1>
        </vs-col>
      </vs-row>
      <template v-if="!showMessage" class="center-component">
        <template>
          <component
            v-for="(el, index) in chartData"
            :key="index"
            :is="el.component"
            class="w-full sm:w-full md:w-full px-2"
            v-show="el.active"
          ></component>
        </template>
      </template>
      <template v-else>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center">
            <p>
              Dirígete a <strong> Profile > Configurar Dashboard </strong> para
              personalizar tu Dashboard.
            </p>
          </vs-col>
        </vs-row>
      </template>
    </div>
  </div>
</template>

<script>
//Loading
import loading from '@/mixins/Loading.js'
//EHS Dashboard
import EhsDonut from './components/EhsDonut.vue'
import EhsTable from './components/EhsTable.vue'
//Compliance Dashboard
import ComplianceDonut from './components/ComplianceDonut.vue'
import ComplianceTable from './components/ComplianceTable.vue'
//Accounting Dashboard
import AccountingPendingDonut from './components/AccountingPendingDonut.vue'
import AccountingRejectedDonut from './components/AccountingRejectedDonut.vue'
import AccountingInvoicedDonut from './components/AccountingInvoicedDonut.vue'
//Entries
import EntriesCards from './components/EntriesCards.vue'
import EntriesAgingDonut from './components/EntriesAgingDonut.vue'
import EntriesWarehouseDonut from './components/EntriesWarehouseDonut.vue'
//Review Orders
import ReviewOrdersCards from './components/ReviewOrdersCards.vue'
import ReviewOrdersBarPlotByClient from './components/ReviewOrdersBarPlotByClient.vue'
import ReviewOrdersDonutByStatus from './components/ReviewOrdersDonutByStatus.vue'
//Load Orders
import LoadOrdersCards from './components/LoadOrdersCards.vue'
//Discrepancies
import DiscrepanciesBarPlotByClient from './components/DiscrepanciesBarPlotByClient.vue'
import DiscrepanciesDonutBySupplier from './components/DiscrepanciesDonutBySupplier.vue'
import DiscrepanciesTreemapByType from './components/DiscrepanciesTreemapByType.vue'
import dashboard from './request/dashboard'
import charts from './charts'
export default {
  components: {
    EhsDonut,
    EhsTable,
    ComplianceDonut,
    ComplianceTable,
    AccountingPendingDonut,
    AccountingInvoicedDonut,
    AccountingRejectedDonut,
    EntriesCards,
    EntriesAgingDonut,
    EntriesWarehouseDonut,
    ReviewOrdersCards,
    ReviewOrdersBarPlotByClient,
    ReviewOrdersDonutByStatus,
    LoadOrdersCards,
    DiscrepanciesBarPlotByClient,
    DiscrepanciesDonutBySupplier,
    DiscrepanciesTreemapByType,
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.setting
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('custom_dashboard_loading')
      } else {
        this.closeLoading('custom_dashboard_loading')
      }
    },
  },
  data() {
    return {
      charts: charts,
      userData: [
        { id: 'DiscrepanciesTypeTreemap', active: false },
        { id: 'DiscrepanciesSupplierDonut', active: false },
        { id: 'DiscrepanciesClientBar', active: false },
        { id: 'LoadOrderStatusCards', active: false },
        { id: 'EntriesWarehouseDonut', active: false },
        { id: 'EntriesAgingDonut', active: false },
        { id: 'EntriesStatusCards', active: false },
        { id: 'EhsTable', active: false },
        { id: 'EhsStatusDonut', active: false },
        { id: 'ComplianceTable', active: false },
        { id: 'ComplianceStatusDonut', active: false },
        { id: 'AccountingRejectedDonut', active: false },
        { id: 'AccountingInvoicedDonut', active: false },
        { id: 'AccountingPendingDonut', active: false },
      ],
      chartData: [],
      loading: {
        setting: false
      },
      showMessage: false
    }
  },
  methods: {
    mergeArray(a1, a2) {
      return a1.map((t1) => ({ ...t1, ...a2.find((t2) => t2.id === t1.id) }))
    },
    getUserData() {
      this.loading.setting = true
      dashboard
        .getUserData()
        .then((response) => {
          this.userData = JSON.parse(response.data.settings)
          if (this.userData == null) {
            this.showMessage = true
          } else {
            if (this.userData.filter(el => el.active == true).length > 0) {
              this.chartData = this.mergeArray(this.userData, this.charts)
            } else {
              this.showMessage = true
            }
          }
          this.loading.setting = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.setting = false
        })
    },
  },
  mounted() {
    this.getUserData()
  }
}
</script>